export const ARKME_HARNESS_EMBED_PATH = '/arkme-self/harness-frame'

export const HARNESS_SESSION_CLIENT_ID = '@senguoyun/dsh-arkme/harness-session'
export const HARNESS_SESSION_CLIENT_PATH = '/arkme-self/harness-session-client.js'
export const ARKME_HARNESS_MODEL_CLIENT_PATH = '/arkme-self/harness-model-client.js'
export const ARKME_HARNESS_ONBOARDING_CLIENT_PATH = '/arkme-self/harness-onboarding-client.js'
